<div class="icon-container">
  <mat-icon
    class="as-pointer"
    mat-dialog-close
    svgIcon="ic-close-green"
  ></mat-icon>
</div>
<p class="as-font-pacifico title">{{ "FOOTER.dates" | translate }}</p>
<div class="list-options">
  <div class="container">
    <img src="/assets/images/cedis.jpeg" alt="" />
  </div>
  <div class="container">
    <p>{{ "FOOTER.select" | translate }}</p>
    @for (item of cedisOptions; track item) {
      <a
        [href]="item.route"
        target="_blank"
        class="as-font-14 as-font-blackish as-pointer"
        >
        &bull; {{ item.label | translate }}
      </a>
    }
  </div>
</div>
